import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import formStyles from '../../../styles/forms.module.scss';
import {
  TextInput,
  RadioGroupInput,
  AccessibleDatepickerInput,
} from '../../../common/FormFields';
import Heading from '../../../common/Heading';
import s from './StepCertificateForm.module.scss';

function StepCo2Form() {
  const namePrefix = 'co2CertificateData.';

  return (
    <section>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepCertificateCo2.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="information.start"
            labelMsg="offerWizard.StepSomeInformation.start.label"
            component={AccessibleDatepickerInput}
            minDate={new Date()}
          />
          <Field
            name="information.end"
            labelMsg="offerWizard.StepSomeInformation.end.label"
            component={AccessibleDatepickerInput}
            minDate={(values) => {
              if (values.information && values.information.start) {
                return new Date(values.information.start);
              }
              return new Date();
            }}
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={`${namePrefix}consumption`}
            component={TextInput}
            labelMsg="offerWizard.StepCertificateCo2.consumption.label"
          />
        </div>
        <Field
          captionMsg="offerWizard.StepCertificateCo2.kindOfCertificate"
          name={`${namePrefix}kindOfCertificate`}
          options={[
            {
              value: 'cer',
              labelText: 'Certified Emission Resources (CER)',
            },
            {
              value: 'ver',
              labelText: 'Verified Emission Resources (VER)',
            },
            {
              value: 'eua',
              labelText: 'European Union Allowance (EUA)',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.kindRadios}
        />
        <Field
          captionMsg="offerWizard.StepCertificateCo2.kindOfContract"
          name={`${namePrefix}kindOfContract`}
          renderCondition={(values) => {
            const { co2CertificateData } = values;
            if (!co2CertificateData) return false;
            const { kindOfCertificate } = co2CertificateData;
            return kindOfCertificate === 'eua';
          }}
          options={[
            {
              value: 'spot_auction',
              labelText: 'Spot/Auktion',
            },
            {
              value: 'future',
              labelText: 'Termin',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.contractKindRadios}
          required
        />
      </div>
    </section>
  );
}

StepCo2Form.propTypes = {};

export default StepCo2Form;
